import {Injectable, Signal, signal} from '@angular/core';
import {Subscription, timer} from 'rxjs';
import {ISnackbar} from '../models/snackbar.models';

@Injectable({
	providedIn: 'root',
})
export class SnackbarService {
	private _snackbar = signal<ISnackbar>({show: false, text: ''});
	private hideTimer: Subscription | null = null;

	public get snackbar(): Signal<ISnackbar> {
		return this._snackbar;
	}

	public setSnackBar(value: ISnackbar): void {
		this._snackbar.set(value);
	}

	public show(label: string) {
		this._snackbar.set({show: true, text: label});
		this.hideTimer?.unsubscribe();
		this.hideTimer = timer(5000).subscribe(() => this.hide());
	}

	public hide() {
		this._snackbar.set({show: false, text: ''});
	}
}
